import { createAuthClient } from "better-auth/react";
console.log("baseurls ---", process.env.REACT_APP_BASE_URL)
export const authClient = createAuthClient({
  baseURL: process.env.REACT_APP_BASE_URL, 
});